import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  toggleContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  toggleBox: {
    minWidth: '0',
    padding: '0',
    margin: '17px',
    width: '30px',
    height: '30px',
    border: '1px solid #eaf2ff70',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  expanded: {
    transition: 'transform 300ms 200ms',
    transform: 'rotate(180deg)',
  },
  closed: {
    transition: 'transform 300ms 200ms',
    transform: 'rotate(0deg)',
  },
}));

export default useStyles;
